module.exports = __webpack_public_path__ + "img/side-car2.49d5e53f.png";